import {Box} from "@mui/material"
import React from "react"
import Content from "../../../components/Content"

const ContainerStyledTableRow = ({row, widget, rowCount, showVerticalBorders, borderColor, columncount}) => {
    const renderWidget = _.cloneDeep(widget)
    if (widget.connections?.origin?.pointer) {
        renderWidget.connections.origin.pointer =
            renderWidget.connections?.origin.pointer.replace("[i]", rowCount)
        renderWidget.subtext =
            renderWidget.subtext?.replace("[i]", rowCount)
    }

    const isLastColumn = widget.x + widget.w >= columncount

    return (
        <Box
            bgcolor={renderWidget.background && "#ddddff"}
            sx={{
                gridColumn: widget.x + 1 + " /span " + widget.w,
                gridRow: widget.y + rowCount + 1 + " /span " + widget.h,
                padding: "8px 12px",
                borderBottom: `1px solid ${borderColor}`,
                borderRight: showVerticalBorders && !isLastColumn
                    ? `1px solid ${borderColor}`
                    : "none",
            }}
        >
            <Content key={renderWidget.i} child={renderWidget} value={row[renderWidget.property]} payload={row} />
        </Box>
    )
}

export default ContainerStyledTableRow
